/**
 * Created by jv on 15/05/2018.
 */
// https://photonstorm.github.io/phaser3-docs/loader_File.js.html#line-34
export default [
  // Misc
  {
    key: "bg_overlay",
    url: require("Images/games/carrot-game/bg_overlay.png"),
    type: "image"
  },
  {
    key: "bg_cloud_green",
    url: require("Images/games/carrot-game/bg_cloud_green.png"),
    type: "image"
  },

  // Track background images
  {
    key: "bg_track_clouds",
    url: require("Images/games/carrot-game/bg_track_clouds.png"),
    type: "image"
  },
  {
    key: "bg_track_grass",
    url: require("Images/games/carrot-game/bg_track_grass.png"),
    type: "image"
  },
  {
    key: "bg_track_ground",
    url: require("Images/games/carrot-game/bg_track_ground.png"),
    type: "image"
  },
  {
    key: "bg_track_mountain",
    url: require("Images/games/carrot-game/bg_track_mountain.png"),
    type: "image"
  },
  {
    key: "bg_track_sky",
    url: require("Images/games/carrot-game/bg_track_sky.jpg"),
    type: "image"
  }
];



// WEBPACK FOOTER //
// ./app/js/games/carrot-game/config/assets.js